import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider.js';
import { isAlphaInviteOnlyUi } from './alpha-invite-ui.js';
import { GoogleContinueButton } from './GoogleContinueButton.js';
const fieldStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem',
    marginBottom: '1rem',
};
export function getPostLoginRedirectPath(location, fallback = '/') {
    const state = location.state;
    if (typeof state === 'object' && state !== null && 'from' in state) {
        const from = state.from;
        if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')) {
            return from;
        }
    }
    return fallback;
}
export function LoginPage() {
    const { user, isLoading, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const from = getPostLoginRedirectPath(location);
    if (isLoading) {
        return _jsx("p", { children: t('common.auth.loading') });
    }
    if (user) {
        return _jsx(Navigate, { to: from, replace: true });
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setError(null);
        try {
            await login({ email, password });
            void navigate(from, { replace: true });
        }
        catch {
            setError('Invalid email or password');
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsxs("section", { style: { maxWidth: '420px' }, children: [_jsx("h1", { style: { fontFamily: 'var(--fm-font-heading)', marginTop: 0 }, children: t('common.auth.loginTitle') }), _jsxs("form", { onSubmit: (event) => void handleSubmit(event), noValidate: true, children: [_jsxs("label", { style: fieldStyle, children: [_jsx("span", { children: t('common.auth.email') }), _jsx("input", { type: "email", autoComplete: "email", required: true, value: email, onChange: (event) => {
                                    setEmail(event.target.value);
                                }, className: "fm-input" })] }), _jsxs("label", { style: fieldStyle, children: [_jsx("span", { children: t('common.auth.password') }), _jsx("input", { type: "password", autoComplete: "current-password", required: true, minLength: 8, value: password, onChange: (event) => {
                                    setPassword(event.target.value);
                                }, className: "fm-input" })] }), error ? (_jsx("p", { role: "alert", className: "fm-error", children: error })) : null, _jsx(Button, { label: t('common.auth.submitLogin'), type: "submit", disabled: submitting })] }), _jsx("div", { style: { marginTop: '1rem' }, children: _jsx(GoogleContinueButton, { disabled: submitting, onSuccess: () => {
                        void navigate(from, { replace: true });
                    }, onError: (message) => {
                        setError(message);
                    } }) }), _jsxs("p", { style: { marginTop: '1rem', color: 'var(--fm-color-text-muted)' }, children: [t('common.auth.noAccount'), ' ', isAlphaInviteOnlyUi(import.meta.env) ? (_jsx(Link, { to: "/accept-invite", children: t('common.nav.haveInvite') })) : (_jsx(Link, { to: "/register", children: t('common.nav.signUp') }))] })] }));
}
//# sourceMappingURL=LoginPage.js.map